import React, {
  RefObject,
} from 'react';
import Table from 'core/components/VirtualTable';
import {
  getEOBsData,
} from 'pages/Dashboard/pages/Billing/api';
import columns from 'pages/Dashboard/pages/Billing/Payments/columns/eobsOverview';
import {
  paymentsEventChannel,
} from 'pages/Dashboard/services/eventChannels';
import {
  VirtualTableInstance,
} from 'core/components/VirtualTable/types';
import {
  useMedia,
} from 'core/hooks';
import {
  OverviewProps,
} from 'pages/Dashboard/pages/Billing/Payments';
import {
  EOBSummaryResponseDTO,
} from 'dtos/eOBSummaryResponseDTO';

export default function EOBsOverview({
  tableInstanceRef,
  searchQuery,
  dateRange,
  filterQuery = {},
}: OverviewProps) {
  const { requestMedia } = useMedia();

  return (
    <div className="flex min-w-0 flex-1 w-full h-full overflow-y-hidden">
      <Table<EOBSummaryResponseDTO>
        dataKey="eobs"
        instanceRef={tableInstanceRef as RefObject<VirtualTableInstance>}
        columns={columns}
        defaultPagination={{
          pageSize: 25,
          pageIndex: 0,
        }}
        skeleton={{ rows: 5 }}
        getData={getEOBsData}
        emptySlot="No EOBs found"
        queryParams={{
          dateRange,
          searchText: searchQuery,
          filterQuery,
          requestMedia,
        }}
        onRowClick={(table, row) => {
          paymentsEventChannel.emit('onEOBDialogOpen', { eobNumber: row.original?.eobNumber ?? undefined });
        }}
        classes={{
          header: 'px-4 !items-end !py-2',
          column: '!text-left !items-end',
          scrollContainer: 'justify-center items-center',
          outerRow: '!w-[calc(100%-16px)] left-4',
        }}
      />
    </div>
  );
}
